/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment, useState } from "react";
import { ReactComponent as FileIcon } from "assets/images/icons/file-solid.svg";

const FileEntityAttribute = (props) => {
    
    const name = props.name;
    const value = props.value;
    const type = props.type;
    // const title = value?.title;
    // const filename = value?.filename;
    // const url = value?.url;

    const parts = type.split(":");
    const baseType = parts[0];
    const subType = parts[1];
    const hasSubType = !!subType;
    let editorType = baseType;
    if (hasSubType) {
        editorType = subType;
    }

    const isList = baseType === "array";
    const [files, setFiles] = useState(value);
    
    if (!value) {
        return null;
    }
    
    return (
        <>
            <div className="entity-attribute-editor-label">
                {name}
            </div>
            <div className="entity-attribute-editor-panel">

                <div className="entity-attribute-editor-file-upload-list">
                    {isList && files?.map((file,index) => {
                        const filename = file?.filename;
                        const title = file?.title;
                        const url = file?.url;
                        return (
                            <div key={`${index}`} className="entity-attribute-editor-file-upload-list-inner">
                                <div className="entity-attribute-editor-file-upload-list-row">
                                    <div className="entity-attribute-editor-file-upload-list-icon">
                                        <FileIcon />
                                    </div>
                                    <div className="entity-attribute-editor-file-upload-list-link-view" >
                                        <div>{title}</div>
                                        <a href={url} target="_blank">{filename}</a>
                                    </div>
                                    {/*<div className="entity-attribute-editor-file-upload-list-textfield">*/}
                                    {/*    <div>{title}</div>*/}
                                    {/*    <div>{filename}</div>*/}
                                    {/*    <div>{url}</div>*/}
                                    {/*</div>*/}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};
FileEntityAttribute.displayName = "FileEntityAttribute";
export { FileEntityAttribute };
